<template>
    <div class="goodsmaterial spackage padding-20 bgc box-shadow">

        <!-- 顶部菜单栏 start -->
        <section class="gcm-header">
            <el-button type="primary" align="left" @click="createCMgt">新增社群</el-button>
            <div align="right" style="float:right">
                <el-select v-model="currentStatus" placeholder="全部状态">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="currentGroup" placeholder="全部状态">
                    <el-option label="全部分组" value=""></el-option>
                    <el-option
                        v-for="item in groupList"
                        :key="item.innerid"
                        :label="item.name"
                        :value="item.innerid">
                    </el-option>
                </el-select>
                <el-input placeholder="请输入社群名称" v-model="searchName" style="width: 240px"></el-input>
                <el-button type="primary" @click="search()" plain>搜索</el-button>
            </div>
        </section>
        <!-- 顶部菜单栏 end -->

        <section>
            <el-table :data="tableData">
                <!-- <el-table-column prop="index" label="序号" align="left" width="80"> </el-table-column> -->
                <el-table-column prop="name" label="社群名称" align="center" width="200" fixed></el-table-column>
                <!-- <el-table-column prop="innerid" label="社群ID" align="center" width="180"></el-table-column> -->
                <el-table-column prop="groupname" label="社群分组" align="center" width="200"></el-table-column>
                <el-table-column prop="usercount" label="用户数" align="center"></el-table-column>
                <el-table-column prop="eventcount" label="活动数" align="center"></el-table-column>
                <el-table-column prop="ordercount" label="订单数" align="center"></el-table-column>
                <el-table-column prop="ordermoney" label="订单金额" align="center"></el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center" width="180"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <div class="table-status">
                            <p class="status-1" v-if="scope.row.status == 1">有效</p>
                            <p class="status-5" v-if="scope.row.status == 0">无效</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="right" width="250">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <el-button v-if="scope.row.status === 1" @click="copyCommunity(scope.row.innerid)">复制</el-button>
                            <span v-if="scope.row.status === 1">|</span>
                            <el-button v-if="scope.row.status === 1" @click="editCommunity(scope.row.innerid, 'edit')">编辑</el-button>
                            <span v-if="scope.row.status === 1">|</span>
                            <el-button v-if="scope.row.status === 1" @click="shareCommunity(scope.row.innerid)">分享</el-button>
                            <span v-if="scope.row.status === 1">|</span>
                            <el-button v-if="scope.row.status === 1" @click="deleteCommunity(scope.row.innerid)">删除</el-button>
                            <el-button v-else @click="editCommunity(scope.row.innerid, 'delete')">详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- end 表单 -->

        <!-- 删除 -- 弹窗 -- start -->
        <el-dialog title="提示" :visible.sync="deleteSureDialog" width="25%" class="dele_dialog">
            <span class="dele_tips">确定删除该社群？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteSureDialog = false">取 消</el-button>
                <el-button type="primary" @click="deleteSureEvent('100')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除 -- 弹窗 -- end -->

        <!-- 删除 -- 弹窗 -- start -->
        <el-dialog title="提示" :visible.sync="deleteDialog" width="25%" class="dele_dialog">
            <span class="dele_tips">当前社群下有有效活动，<br>不能进行删除！</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialog = false, deleteSureDialog = false">取 消</el-button>
                <el-button type="primary" @click="deleteDialog = false, deleteSureDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除 -- 弹窗 -- end -->

        <!-- 分享 -- 弹窗 -- start -->
        <el-dialog :visible.sync="shareDialogVisible" class="share_box" :show-close="false" destroy-on-close>
            <div class="box">
                <h3>{{shareData.assname}}</h3>
                <img :src="shareData.assurl" :alt="shareData.assname">
                <div class="pr-code-text cursor" @click="download(shareData.assurl, shareData.assname)"><span class="tc-blue blod">下载二维码</span></div>
                <div class="copy_box">
                    <el-input v-model.trim="shareData.assurlImg" placeholder="" disabled></el-input>
                    <el-button  type="primary" size="mini" v-clipboard:copy="shareData.assurlImg" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 分享 -- 弹窗 -- end -->


        <section>
            <el-pagination background layout="prev,pager,next" :total="rowCount"  @current-change="fPage()" :current-page.sync="currentPage" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- end 分页 -->

    </div>
</template>

<script>
import {getAssociationsList, getAgbCommGroupSimpleList, deleteStarsockpuppet, updateAssociationsByStatus, shareAssociations, saveCopyAss} from '@/api/cPurchaseApi'
import {getCookie} from '@/common/js/tools'
import {mapActions} from 'vuex'
import $ from 'jquery'
import {urlToQRCode, downloadImage} from 'common/js/tools'

export default {
    name: 'mOPIndex',
    data() {
        return {
            // currentPage: 1,
            rowCount: 0,    // 总页数
            page: 1,    // 当前页数
            tableData: [],      // 社群表单
            statusList: [   // 社群搜索状态列表
                {
                    value: 1,
                    label: '有效'
                },
                {
                    value: 0,
                    label: '无效'
                }
            ],
            groupList: [],  // 选中社群表单
            deleteDialog: false,    // 禁止删除弹窗展示控制
            deleteSureDialog: false,    // 删除确定弹窗展示控制
            searchName: '', // 社群搜索名称
            currentStatus: '',  // 社群搜索状态
            currentGroup: '',   // 社群分组名称
            // isStop: false,  //
            currentid: '',  //  社群ID
            shareData: {},  //  社群分享数据
            shareDialogVisible: false   // 社群分享展示控制
        }
    },
    mounted() {
        this.setLoading(true)
        this.getCGroupList()
        this.getCommunityList(1)
    },
    methods: {
        // 获取社群分组列表
        getCGroupList() {
            getAgbCommGroupSimpleList({
                data: '',
                success: data => {
                    if (data.data.content) {
                        this.groupList = data.data.content
                    }
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 新增
        createCMgt() {
            this.$router.push({ name: 'createCMgt'})
        },

        // 编辑
        editCommunity(id, type) {
            this.$router.push({ name: 'createCMgt', query: {'innerid': id, 'type': type}})
        },

        // 复制社群
        copyCommunity(id) {
            let data = {
                assinnerid: id
            }
            this.setLoading(true)
            saveCopyAss({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.$message.success('社群复制成功！')
                    this.getCommunityList(1)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 分享
        shareCommunity(id) {
            // console.log(id)
            let data = {
                assinnerid: id
            }
            this.setLoading(true)
            shareAssociations({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        this.shareData = data.data
                        this.shareData.assurlImg = this.shareData.assurl
                        this.shareData.assurl = urlToQRCode(this.shareData.assurl)
                        this.shareDialogVisible = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },

        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },

        cancel() {
            this.shareDialogVisible = false
            this.shareData = {}
        },

        onError(e) {
            alert('失败')
        },

        // 删除
        deleteCommunity(id) {
            // this.deleteDialog = true
            this.deleteSureDialog = true
            this.currentid = id
        },

        // 删除社群 调用接口
        deleteSureEvent() {
            let data = {
                assinnerid: this.currentid
            }
            this.setLoading(true)
            updateAssociationsByStatus({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.deleteSureDialog = false
                    this.getCommunityList(1)
                },
                error: data => {
                    this.setLoading(false)
                    if (data.code === '301') {
                        this.deleteDialog = true
                    }
                }
            })
        },

        // 获取社群拼购列表
        getCommunityList(page) {
            // console.log(page)
            let data = {
                name: this.searchName,
                status: this.currentStatus,
                groupInnerid: this.currentGroup,
                page: page,
                pageSize: 10
            }
            this.setLoading(true)
            getAssociationsList({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },
        
        // 社群搜索
        search() {
            // console.log(this.currentStatus)
            // this.setLoading(true)
            this.getCommunityList(1)
        },

        // 分页
        fPage() {
            // this.setLoading(true)
            let clickPage = $('.el-pagination .active').html()
            this.getCommunityList(clickPage)
        },

        ...mapActions([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/starmgt";
    .goodsmaterial {
        .share_box {
            .el-dialog {
                width: 305px;
                height: 320px;
                .el-dialog__header {
                    padding: unset;
                }
                .box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    height: 270px;
                    img {
                        width: 150px;
                        height: 150px;
                    }
                    .copy_box {
                        display: flex;
                        justify-content: space-between;
                        .el-input__inner {
                            border-radius: 4px 0 0 4px;
                        }
                        .el-button {
                            margin-bottom: unset;
                            border-radius: 0 4px 4px 0;
                        }
                    }
                }
            }
        }
        .el-table {
            .sub-title {
                display: -webkit-box;
                max-height: 40px;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;
                -ms-box-orient: vertical;
                box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

        }
        .gcm-header {
            height: 40px;
            margin-bottom: 40px;
            .el-input__icon {
                height: 36px ;
            }
            .el-select,
            .el-select>.el-input,
            .el-button {
                height: 32px;
            }
            .el-select {
                width: 116px;
            }
            .el-select,
            .el-input {
                margin-right: 20px;
            }
        }
        .table-title {
            img {
                width: 106px;
                height: 60px;
            }

            .table-txt {
                display: block;
                width: calc(100% - 126px);
                height: 70px;
                p {
                    width: 100%;
                    height: 40px;
                }
            }

        }
        .table-position {
            .el-dropdown-link {
                a {
                    color: #303133;
                }
            }
        }
        .dele_dialog {
            border-radius: 4px;
            text-align: center;
            .dele_tips {
                color: #F56C6C;
            }
        }
        .table-status {
            .status-4 {
                color: #E6A23C
            }
            .status-5 {
                color: #606266
            }
        }
    }
</style>
